import styles from "./SidebarComponent.module.css";
import { Link, useNavigate } from "react-router-dom";
import design_icon from "../../assets/images/icons/design_icon.svg";

import shopping_bag_icon from "../../assets/images/icons/shopping_bag_icon.png";
import top_design from "../../assets/images/top_design.jpg";

import top_box from "../../assets/images/top_box.png";
import top_gallery from "../../assets/images/top_gallery.jpg";
import top_lock from "../../assets/images/top_lock.png";
import top_love from "../../assets/images/top_love.jpg";
import top_page from "../../assets/images/top_page.jpg";
const SidebarComponent = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.side_menu}>
      <div className={styles.first_column_heading}>
        <div className={`${styles.first_column_heading_1}`}>
          <Link to={"/"}>
            <button>TOPページ</button>
          </Link>
        </div>
        <div className={`${styles.first_column_heading_1}`}>{`>`}</div>
        <div>マイページ</div>
      </div>

      <ul className={`${styles.side_bar_list}`}>
        <li>メニュー</li>
        <li>
          <img className={styles.icon_lock} src={top_lock} alt="top_lock" />
          <span>
            <Link to={"/onlineshop"}>
              <button>オンラインショップ</button>
            </Link>
          </span>
        </li>
        <li
          onClick={() => {
            navigate("/favorite-product");
          }}
        >
          <img className={styles.icon_love} src={top_love} alt="top_love" />
          <span>お気に入りアイテム</span>
        </li>
        <li
          onClick={() => {
            navigate("/check-history");
          }}
        >
          <img className={styles.icon_lock} src={top_lock} alt="top_lock" />
          <span>履歴確認</span>
        </li>
        <li
          onClick={() => {
            navigate("/user-settings");
          }}
        >
          <img className={styles.icon_document} src={top_page} alt="top_page" />
          <span>会員情報変更・配送先登録</span>
        </li>
        <li
          onClick={() => {
            navigate("/gallery-front");
          }}
        >
          <img
            className={styles.gallery_icon}
            src={top_gallery}
            alt="top_gallery"
          />
          <span>ギャラリー</span>
        </li>
        <li
          onClick={() => {
            navigate("/design-box");
          }}
        >
          <img
            className={styles.design_icon}
            src={design_icon}
            alt="design_icon"
          />
          <span>デザインBOX</span>
        </li>
        <li
          onClick={() => {
            navigate("/annual-pass-contract-status");
          }}
        >
          <div className={styles.cloud_icon}>
            <ion-icon name="cloud-done"></ion-icon>
          </div>
          <span>年間パス契約状況</span>
        </li>
        <li
          onClick={() => {
            navigate("/visit-registration");
          }}
        >
          <img className={styles.shop_icon} src={top_box} alt="top_box" />
          <span>来店登録</span>
        </li>
      </ul>
    </div>
  );
};
export default SidebarComponent;
